import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Input, Select, Switch, notification } from "antd";
import queryString from "query-string";
import { createSpecialDeliveryOrder } from "../redux/actions/specialDeliveryActions";

const { Option } = Select;

const layout = {
  style: { margin: "24px" },
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const subCategoryOptions = ["opening", "promo", "emergency", "vip"];

const SpecialDeliveries = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { authToken, clientId } = queryString.parse(location.search);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleError = useCallback(
    (error = {}) => {
      const { message = "", data = {} } = error;
      navigate(`/error-fallback${location.search}`, {
        state: { from: location, message, data },
      });
    },
    [navigate, location]
  );

  const onFinish = (values) => {
    if (isSubmitting) {
      return;
    }

    const { special, subCategory, orderId, reasonCode, approver } = values;

    if (!special) {
      notification.error({
        message: "Please tag this order as special before submitting",
        placement: "bottomRight",
      });
      return;
    }

    const requestObject = {
      orderId,
      subCategory,
      reasonCode,
      category: "SPECIAL",
    };
    if (approver) {
      requestObject.approver = approver;
    }

    const authParams = { clientId, authToken };

    setIsSubmitting(true);

    dispatch(
      createSpecialDeliveryOrder(
        requestObject,
        authParams,
        navigate,
        handleError
      )
    )
      .then((result) => {
        if (result) {
          notification.success({
            message: "Special Delivery Created",
            placement: "bottomRight",
          });
          form.resetFields();
          return;
        }
        notification.error({
          message: "Error Creating Special Delivery",
          placement: "bottomRight",
        });
      })
      .catch(() => {
        notification.error({
          message: "Error Creating Special Delivery",
          placement: "bottomRight",
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <Form
      {...layout}
      form={form}
      name="special-deliveries"
      size="middle"
      onFinish={onFinish}
    >
      <Form.Item label="Special" name="special" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item
        label="Sub Category"
        name="subCategory"
        rules={[
          {
            required: true,
            message: "Please select a sub-category!",
          },
        ]}
      >
        <Select placeholder="Select sub-category" style={{ width: "187px" }}>
          {subCategoryOptions.map((subCategory) => (
            <Option key={subCategory} value={subCategory}>
              {subCategory}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Order Id"
        name="orderId"
        rules={[
          {
            required: true,
            message: "Please input an order id!",
          },
        ]}
      >
        <Input placeholder="Order ID" />
      </Form.Item>
      <Form.Item
        label="Reason Code"
        name="reasonCode"
        rules={[
          {
            required: true,
            message: "Please input a reason code!",
          },
        ]}
      >
        <Input placeholder="Reason Code" />
      </Form.Item>
      <Form.Item label="Approver" name="approver">
        <Input placeholder="Approver" />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button
          type="primary"
          htmlType="submit"
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SpecialDeliveries;
